<template>
  <ul class="product-options">
    <li
      v-for="option in optionsWithVariants"
      :key="`option-${option.position}`"
      class="product-option-group"
    >
      <h2 class="product__label">
        {{ option.name.toLowerCase() == 'size' ? strings.chooseSize : 'Select:' }}
      </h2>
      <ul class="product-option-group__values flex flex-wrap">
        <li
          v-for="value in option.values"
          :key="`option-${option.position}-value-${value.public_title}`"
          class="product-option-group__value"
        >
          <label
            :for="`option-${option.position}-value-${value.public_title}`"
            class="product-option-group__value-cta"
          >
            <input
              :id="`option-${option.position}-value-${value.public_title}`"
              v-model="currentSelectedVariant"
              :value="value"
              type="radio"
              :name="option.name"
              :checked="currentSelectedVariant.id === value.id"
              :disabled="!value.available"
            >
            <span>
              {{ value.public_title }}
            </span>
          </label>
        </li>
      </ul>
    </li>
  </ul>

  <ProductAddActions />
</template>

<script>
import { useProductStore } from '../../pinia/ProductStore'
import { mapState, mapActions } from 'pinia'

import ProductAddActions from './product-add-actions'


export default {
  components: {
    ProductAddActions
  },
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    options: {
      type: Array,
      default: () => []
    },
    variants: {
      type: Array,
      default: () => []
    },
    hiddenVariantIds: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      strings: { ...window.theme.strings.product },
      currentSelectedVariant: {},
      selectedOptionValues: {},
    }
  },
  computed: {
    ...mapState (useProductStore, ['selectedVariant']),

    visibleVariants () {
      if (!this.hiddenVariantIds.length) {
        return this.variants
      }

      return this.variants.filter(variant => !this.hiddenVariantIds.includes(variant.id))
    },

    optionsWithVariants () {
      const options = this.options.map(option => ({
        ...option,
        values: [...option.values]
      }))

      options.forEach((option, optionIndex) => {
        const currentOptionPosition = option.position
        const currentOptionPositionKey = `option${option.position}`
        const otherOptions = this.options.filter(option => option.position !== currentOptionPosition)
        const visibleValues = []

        option.values.forEach((value) => {
          const variant = this.visibleVariants.find(variant => {
            let match = true

            if (variant[currentOptionPositionKey] !== value) {
              match = false
              return
            }

            otherOptions.forEach(option => {
              const optionKey = `option${option.position}`
              if (variant[optionKey] !== this.selectedOptionValues[optionKey]) {
                match = false
                return
              }
            })

            return match
          })

          if (variant) {
            visibleValues.push({ ...variant })
          }
        })

        options[optionIndex].values = visibleValues
      })

      return options.filter(option => option.values.length)
    }
  },
  watch: {
    currentSelectedVariant (variant) {
      this.changeVariant(variant)
    }
  },
  async mounted () {
    await this.setDefaultSelectedVariant()
    this.getDefaultSelectedOptionValues()
  },
  methods: {
    ...mapActions(useProductStore, [
      'changeVariant'
    ]),

    getDefaultSelectedOptionValues () {
      this.options.forEach((option, index) => {
        const optionKey = `option${index  + 1}`
        this.selectedOptionValues[optionKey] = this.currentSelectedVariant[optionKey]
      })
    },
    setDefaultSelectedVariant () {
      this.currentSelectedVariant = this.selectedVariant
    }
  }
}
</script>
